import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const FreeEbookDownloadBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => (
  <TemplateBuilderFactory template="free_ebook_download" {...maxFollowUpCounts}>
    {props => (
      <TemplateBuilderContainer
        enabled={!props.busy && props.isValid}
        confirm={props.confirm}
      >
        <TemplateBuilderInputTriggerSection>
          <div>
            On {props.channelName}, when someone {props.triggersSelect}, send{' '}
            {props.channelMessageName} to attempt to collect their{' '}
            {props.collectionSelect}, then ask them{' '}
            {props.qualifyingQuestionSelect}, then send your file as an
            attachment.
          </div>
        </TemplateBuilderInputTriggerSection>
        <TemplateSubsectionLink />
        <TemplateBuilderReengagementSection>
          <div>
            Using the data collected from {props.channelName}, if the user was
            sent the file, send them a {props.unicornEmailSelect} Email and{' '}
            {props.unicornSMSSelect} SMS text message sequence to follow up
            about the content you shared containing next steps.
          </div>
        </TemplateBuilderReengagementSection>
      </TemplateBuilderContainer>
    )}
  </TemplateBuilderFactory>
);
